module.exports = __webpack_public_path__ + "static/media/grey-black.bce8d20c.png";